import { usePdfProjectItemsQuery } from "src/routes/pdfs/PdfProjectItems.generated";
import { StringParam, useQueryParam } from "use-query-params";

export function usePdfProjectItemsQueryWithQueryParams() {
  const [projectItemIds] = useQueryParam("projectItemIds", StringParam);
  const id = projectItemIds?.split(",") ?? [];
  return usePdfProjectItemsQuery({ variables: { id } });
}
